export const sections = {
  schedule: {
    label: 'general.schedule',
    icon: 'schedule',
    info: 'components.manage.pages.sections.schedule',
    path: '/manage/schedule',
    tags: ['calendar', 'bookings', 'timeline', 'slot size', 'start', 'week', 'time', 'threshold', 'time format', 'start day', 'schedule', 'block size'],
  },
  location: {
    label: 'general.location',
    icon: 'location',
    info: 'components.manage.pages.sections.location',
    path: '/manage/location',
    tags: ['location', 'settings', 'business', 'timezone', 'time zone', 'address', 'contact', 'contact details', 'sales', 'receipts', 'docket', 'locale', 'logo', 'currency', 'tax', 'date format', 'language'],
  },
  theme: {
    label: 'general.theme',
    icon: 'location',
    info: 'components.manage.pages.sections.theme',
    path: '/manage/theme',
    tags: ['theme', 'colour', 'color', 'dark', 'mode', 'style', 'look', 'design'],
  },
  employees: {
    label: 'general.employees',
    icon: 'attendees',
    info: 'components.manage.pages.sections.employees',
    path: '/manage/employees',
    tags: ['contract', 'employees', 'users', 'settings', 'services', 'overrides', 'staff', 'team', 'chairs', 'therapist', 'personnel', 'practitioner'],
  },
  resources: {
    label: 'general.resources',
    icon: 'resources',
    info: 'components.manage.pages.sections.resources',
    path: '/manage/resources',
    tags: ['assets', 'pool', 'materials', 'rooms', 'tools', 'equipment', 'mcahines'],
  },
  resourceGroups: {
    label: 'general.resourceGroups',
    icon: 'resourceGroup',
    info: 'components.manage.pages.sections.resourcesGroups',
    path: '/manage/resource-groups',
    tags: ['assets', 'pool', 'materials', 'rooms', 'tools', 'equipment', 'type', 'category'],
  },
  services: {
    label: 'general.services',
    icon: 'services',
    info: 'components.manage.pages.sections.services',
    path: '/manage/services',
    tags: ['classes', 'sessions', 'bookings', 'options', 'treatments', 'menu', 'therapies'],
  },
  serviceCategories: {
    label: 'manage.pages.serviceCategories',
    icon: 'serviceCategory',
    info: 'components.manage.pages.sections.serviceCategories',
    path: '/manage/service-categories',
    tags: ['classes', 'sessions', 'bookings', 'options', 'groups', 'section', 'sort', 'types'],
  },
  beforeAfterCare: {
    label: 'manage.pages.serviceAutomationTemplates',
    icon: 'sparkles',
    info: 'components.manage.pages.sections.serviceAutomationTemplates',
    path: '/manage/service-automation-templates',
    tags: ['before', 'after', 'care', 'service', 'automation', 'follow up', 'messages', 'templates'],
  },  
  statusTypes: {
    label: 'manage.pages.statusTypes',
    icon: 'statusType',
    info: 'components.manage.pages.sections.statusTypes',
    path: '/manage/appointment-status-types',
    tags: ['status', 'tags', 'flags'],
  },
  cancellationReasons: {
    label: 'manage.pages.cancellationReasons',
    icon: 'cancel',
    info: 'components.manage.pages.sections.cancellationReasons',
    path: '/manage/cancellation-reasons',
    tags: ['remove', 'notes', 'flags'],
  },
  products: {
    label: 'general.products',
    icon: 'product',
    info: 'components.manage.pages.sections.products',
    path: '/manage/products',
    tags: ['items', 'goods', 'merchandise', 'inventory', 'retail', 'stock'],
  },
  productCategories: {
    label: 'manage.pages.productCategories',
    icon: 'productCategory',
    info: 'components.manage.pages.sections.productCategories',
    path: '/manage/product-categories',
    tags: ['group', 'section', 'sort', 'type'],
  },
  brands: {
    label: 'manage.pages.brands',
    icon: 'brand',
    info: 'components.manage.pages.sections.brands',
    path: '/manage/brands',
    tags: ['make', 'variety', 'manufacturer'],
  },
  suppliers: {
    label: 'manage.pages.suppliers',
    icon: 'supplier',
    info: 'components.manage.pages.sections.suppliers',
    path: '/manage/suppliers',
    tags: ['make', 'variety', 'manufacturer', 'vendor'],
  },
  purchaseOrders: {
    label: 'general.purchaseOrders',
    icon: 'purchaseOrder',
    info: 'components.manage.pages.sections.purchaseOrders',
    path: '/manage/purchase-orders',
    tags: ['types', 'quantity', 'price', 'seller', 'document', 'PO'],
  },
  stockTake: {
    label: 'general.stockTake',
    icon: 'stockTake',
    info: 'components.manage.pages.sections.stockTake',
    path: '/manage/stock-take',
    tags: ['inventory', 'checking', 'counting', 'wall', 'audit'],
  },
  taxes: {
    label: 'general.taxes',
    icon: 'schedule',
    info: 'components.manage.pages.sections.taxes',
    path: '/manage/taxes',
    tags: ['levy', 'tariff', 'duty', 'toll', 'sales', 'VAT', 'GST', 'PST'],
  },
  details: {
    label: 'general.details',
    icon: 'details',
    info: 'components.manage.pages.sections.details',
    path: '/manage/details',
    tags: ['sales', 'details', 'receipt', 'tax'],
  },
  customFieldsCustomer: {
    label: 'general.customer',
    icon: 'schedule',
    info: 'components.manage.pages.sections.customFieldsCustomer',
    path: '/manage/custom-fields-customer',
    tags: ['input', 'entry', 'data', 'customer'],
  },
  customFieldsReservation: {
    label: 'general.appointment',
    icon: 'attendees',
    info: 'components.manage.pages.sections.customFieldsReservation',
    path: '/manage/custom-fields-reservation',
    tags: ['input', 'entry', 'data'],
  },
  customFieldsReservationCustomer: {
    label: 'manage.pages.groupCustomer',
    icon: 'schedule',
    info: 'components.manage.pages.sections.customFieldsReservationCustomer',
    path: '/manage/custom-fields-reservationCustomer',
    tags: ['input', 'entry', 'data', 'attendee', 'customer'],
  },
  customFieldsSale: {
    label: 'general.sale',
    icon: 'attendees',
    info: 'components.manage.pages.sections.customFieldsSale',
    path: '/manage/custom-fields-order',
    tags: ['input', 'entry', 'data', 'sale', 'order', 'purchase'],
  },
  customFieldsEmployee: {
    label: 'general.employee',
    icon: 'employee',
    info: 'components.manage.pages.sections.customFieldsEmployee',
    path: '/manage/custom-fields-employee',
    tags: ['input', 'entry', 'data', 'employee'],
  },
  customFieldsService: {
    label: 'general.service',
    icon: 'services',
    info: 'components.manage.pages.sections.customFieldsService',
    path: '/manage/custom-fields-service',
    tags: ['input', 'entry', 'data', 'service'],
  },
  customFieldsProducts: {
    label: 'general.product',
    icon: 'product',
    info: 'components.manage.pages.sections.customFieldsProduct',
    path: '/manage/custom-fields-product',
    tags: ['input', 'entry', 'data', 'product'],
  },
  forms: {
    label: 'general.forms',
    icon: 'schedule',
    info: 'components.manage.pages.sections.forms',
    path: '/manage/forms',
    tags: ['forms', 'screening', 'collect', 'survey', 'consultation', 'questionnaire', 'SOAP', 'intake', 'medical history', 'contraindications', 'consent', 'declaration', 'disclaimer', 'health', 'signature', 'aftercare'],
  },
  customerGiftCards: {
    label: 'manage.pages.customerGiftCards',
    icon: 'giftCard',
    info: 'components.manage.pages.sections.customerGiftCards',
    path: '/manage/customer-gift-cards',
    tags: ['present', 'voucher', 'certificate', 'purchase', 'coupon'],
  },
  passes: {
    label: 'general.passes',
    icon: 'pass',
    info: 'components.manage.pages.sections.passes',
    path: '/manage/pass',
    tags: ['location', 'pass', 'discount', 'voucher', 'class', 'course', 'membership'],
  },
  customerPasses: {
    label: 'manage.pages.customerPasses',
    icon: 'pass',
    info: 'components.manage.pages.sections.customerPasses',
    path: '/manage/customer-pass',
    tags: ['location', 'pass', 'discount', 'voucher', 'class', 'active'],
  },
  loyaltyProgram: {
    label: 'manage.pages.loyaltyProgramSettings',
    icon: 'loyaltyPoints',
    info: 'components.manage.pages.sections.loyaltyProgram',
    path: '/manage/loyalty-program',
    tags: ['scheme', 'points', 'reward', 'loyalty', 'points', 'program'],
  },
  activeVouchers: {
    label: 'manage.pages.activeVouchers',
    icon: 'pass',
    info: 'components.manage.pages.sections.activeVouchers',
    path: '/manage/active-promo-codes',
    tags: ['discount', 'coupon', 'ticket', 'voucher', 'promotion', 'special'],
  },
  expiredVouchers: {
    label: 'manage.pages.expiredVouchers',
    icon: 'pass',
    info: 'components.manage.pages.sections.expiredVouchers',
    path: '/manage/expired-promo-codes',
    tags: ['discount', 'coupon', 'ticket', 'voucher', 'promotion'],
  },
  discounts: {
    label: 'general.discounts',
    icon: 'discount',
    info: 'components.manage.pages.sections.discounts',
    path: '/manage/discounts',
    tags: ['discount', 'coupon', 'preset', 'sale', 'order', 'purchase'],
  },
  charges: {
    label: 'order.charges',
    icon: 'charge',
    info: 'components.manage.pages.sections.charges',
    path: '/manage/charges',
    tags: ['charge', 'coupon', 'preset', 'sale', 'order', 'purchase', 'fees'],
  },
  payments: {
    label: 'general.payments',
    icon: 'payment',
    info: 'components.manage.pages.sections.payments',
    path: '/manage/payments',
    tags: ['payments', 'coupon', 'preset', 'sale', 'order', 'purchase'],
  },
  templates: {
    label: 'manage.pages.templates',
    icon: 'template',
    info: 'components.manage.pages.sections.templates',
    path: '/manage/templates',
    tags: ['templates', 'email', 'preset', 'document', 'notification', 'automated'],
  },
  email: {
    label: 'general.email',
    icon: 'email',
    info: 'components.manage.pages.sections.email',
    path: '/manage/email',
    tags: ['email', 'template', 'passbook', 'gmail', 'notification', 'automated'],
  },
  sms: {
    label: 'general.sms',
    icon: 'phone',
    info: 'components.manage.pages.sections.sms',
    path: '/manage/sms',
    tags: ['sms', 'number', 'system', 'country', 'credits', 'pricing', 'text', 'messages'],
  },
  reminders: {
    label: 'general.reminders',
    icon: 'reminder',
    info: 'components.manage.pages.sections.reminders',
    path: '/manage/reminders',
    tags: ['appointment', 'sms', 'birthday', 'alert', 'notification', 'automated', 'text', 'messages'],
  },
  segments: {
    label: 'general.segments',
    icon: 'customerSegments',
    info: 'manage.pages.sections.segments',
    path: '/manage/segments',
    tags: ['customer', 'segments', 'group', 'category', 'tag', 'VIP'],
  },
}

export const pages = [
  {
    value: 'preferences',
    label: 'general.preferences',
    icon: 'preferences',
    info: 'components.manage.pages.pages.preferences',
    path: '/manage/location',
    match: '/manage/location',
    tabs: {
      location: sections.location,
      schedule: sections.schedule,
      theme: sections.theme,
    },
  },
  {
    value: 'employees',
    label: 'general.employees',
    icon: 'employee',
    info: 'components.manage.pages.pages.employees',
    path: '/manage/employees',
    match: '/manage/employees',
    tabs: {
      employees: sections.employees,
    },
  },
  {
    label: 'general.services',
    icon: 'services',
    info: 'components.manage.pages.pages.services',
    path: '/manage/services',
    match: '/manage/services',
    value: 'services',
    tabs: {
      services: sections.services,
      serviceCategories: sections.serviceCategories,
      statusTypes: sections.statusTypes,
      cancellationReasons: sections.cancellationReasons,
      beforeAfterCare: sections.beforeAfterCare,
    },
  },
  {
    value: 'resources',
    label: 'general.resources',
    icon: 'resources',
    info: 'components.manage.pages.pages.resources',
    path: '/manage/resources',
    match: '/manage/resources',
    tabs: {
      resources: sections.resources,
      resourceGroups: sections.resourceGroups,
      // resourceTypes: sections.resourceTypes
    },
  },
  {
    label: 'manage.pages.remindersAndNotifications',
    icon: 'notification',
    info: 'components.manage.pages.pages.remindersAndNotifications',
    path: '/manage/templates',
    match: '/manage/templates',
    value: 'notification',
    tabs: {
      reminders: sections.reminders,
      sms: sections.sms,
      templates: sections.templates,
      email: sections.email,
    },
  },
  {
    label: 'general.forms',
    icon: 'forms',
    info: 'components.manage.pages.pages.forms',
    path: '/manage/forms',
    match: '/manage/forms',
    value: 'forms',
    tabs: {
      forms: sections.forms,
    },
  },
  {
    label: 'general.products',
    icon: 'product',
    info: 'components.manage.pages.pages.products',
    path: '/manage/products',
    match: '/manage/products',
    value: 'products',
    tabs: {
      products: sections.products,
      productCategories: sections.productCategories,
      brands: sections.brands,
      suppliers: sections.suppliers,
      purchaseOrders: sections.purchaseOrders,
      stockTake: sections.stockTake,
    },
  },
  {
    label: 'manage.pages.pointOfSale',
    icon: 'payment',
    info: 'components.manage.pages.pages.pointOfSale',
    path: '/manage/details',
    match: '/manage/point-of-sale',
    value: 'details',
    tabs: {
      details: sections.details,
      taxes: sections.taxes,
      discounts: sections.discounts,
      charges: sections.charges,
      payments: sections.payments,
    },
  },
  {
    label: 'general.giftCards',
    icon: 'giftCard',
    info: 'components.manage.pages.pages.customerGiftCards',
    path: '/manage/customer-gift-cards',
    match: '/manage/gift-cards',
    value: 'giftCards',
    tabs: {
      customerGiftCards: sections.customerGiftCards,
    },
  },
  {
    label: 'general.passes',
    icon: 'pass',
    info: 'components.manage.pages.pages.passes',
    path: '/manage/pass',
    match: '/manage/pass',
    value: 'passes',
    tabs: {
      passes: sections.passes,
      customerPasses: sections.customerPasses,
    },
  },
  {
    label: 'manage.pages.promoCodes',
    icon: 'pass',
    info: 'components.manage.pages.pages.promoCodes',
    path: '/manage/active-promo-codes',
    match: '/manage/promo codes',
    value: 'promoCodes',
    tabs: {
      activeVouchers: sections.activeVouchers,
      expiredVouchers: sections.expiredVouchers,
    },
  },
  {
    label: 'manage.pages.loyaltyProgram',
    icon: 'loyaltyPoints',
    info: 'components.manage.pages.pages.loyaltyPoints',
    path: '/manage/loyaltyProgram',
    value: 'loyaltyProgram',
    tabs: {
      loyaltyProgram: sections.loyaltyProgram,
    },
  },
  {
    label: 'general.segments',
    icon: 'customerSegments',
    info: 'manage.pages.segments',
    path: '/manage/segments',
    match: '/manage/segments',
    value: 'segments',
    tabs: {
      segments: sections.segments,
    },
  },
  {
    label: 'general.customFields',
    icon: 'customFields',
    info: 'components.manage.pages.pages.customFields',
    path: '/manage/custom-fields-customer',
    match: '/manage/custom-fields',
    value: 'customFields',
    tabs: {
      customFieldsCustomer: sections.customFieldsCustomer,
      customFieldsReservation: sections.customFieldsReservation,
      customFieldsReservationCustomer: sections.customFieldsReservationCustomer,
      customFieldsSale: sections.customFieldsSale,
      customFieldsEmployee: sections.customFieldsEmployee,
      customFieldsService: sections.customFieldsService,
      customFieldsProducts: sections.customFieldsProducts,
    },
  },
]
